/** @format */

import React, { useEffect, useState } from "react";
import { DownOutlined, LogoutOutlined, UserOutlined } from "@ant-design/icons";
import { Avatar } from "antd";
import type { MenuProps } from "antd";
import { Trans } from "react-i18next";
import { useHistory } from "react-router";
import Dropdown from "common/Dropdown";
import { ADMIN_NAME_STORAGE_KEY } from "infrastructure/utils/adminDisplayName";
import { clearNotificationSession } from "features/notifications/session";
import storage from "infrastructure/utils/storage";
import {
  AdminName,
  HeaderPill,
  LogoutMenuItem,
  UserMenuTrigger,
} from "./style";

const Logout = () => {
  const history = useHistory();
  const [adminName, setAdminName] = useState(
    () => storage.getItem(ADMIN_NAME_STORAGE_KEY) ?? ""
  );

  useEffect(() => {
    setAdminName(storage.getItem(ADMIN_NAME_STORAGE_KEY) ?? "");
  }, []);

  const handleLogout = () => {
    storage.clearItem("access_token");
    storage.clearItem("role");
    storage.clearItem(ADMIN_NAME_STORAGE_KEY);
    clearNotificationSession();
    history.push("/login");
  };

  const menuItems: MenuProps["items"] = [
    {
      key: "logout",
      label: (
        <LogoutMenuItem>
          <LogoutOutlined />
          <Trans>logout</Trans>
        </LogoutMenuItem>
      ),
      onClick: handleLogout,
    },
  ];

  return (
    <Dropdown menu={{ items: menuItems }} placement="bottomRight">
      <UserMenuTrigger type="button">
        <HeaderPill>
          <Avatar size={32} icon={<UserOutlined />} />
          <AdminName>{adminName}</AdminName>
          <DownOutlined />
        </HeaderPill>
      </UserMenuTrigger>
    </Dropdown>
  );
};

export default Logout;
